export default __webpack_public_path__ + "static/media/review_ad.021c17e5.png";